import type { RemotePlayer, RuntimeMob, NpcRuntimeData, ChestInventoryRow, Npc, TilePosition, VisualAssetPlacement } from './types';

export class EntityStore {
  private remotePlayers: Map<string, RemotePlayer> = new Map();
  private visualAssets: VisualAssetPlacement[] = [];
  private npcs: Npc[] = [];
  private runtimeMobs: RuntimeMob[] = [];
  private npcRuntime: NpcRuntimeData[] = [];
  private chestInventory: ChestInventoryRow[] = [];
  private snapNextMoveByEntityId: Map<string, TilePosition> = new Map();

  public updateRemotePlayers(players: RemotePlayer[]): void {
    this.remotePlayers.clear();
    for (const player of players) {
      this.remotePlayers.set(player.entityId, player);
    }
  }

  public getRemotePlayers(): RemotePlayer[] {
    return Array.from(this.remotePlayers.values());
  }

  public updateVisualAssets(assets: VisualAssetPlacement[]): void {
    this.visualAssets = assets;
  }

  public getVisualAssets(): VisualAssetPlacement[] {
    return this.visualAssets;
  }

  public updateNpcs(npcs: Npc[]): void {
    this.npcs = npcs;
  }

  public getNpcs(): Npc[] {
    return this.npcs;
  }

  public updateRuntimeMobs(mobs: RuntimeMob[]): void {
    this.runtimeMobs = mobs;
  }

  public getRuntimeMobs(): RuntimeMob[] {
    return this.runtimeMobs;
  }

  public updateNpcRuntime(npcs: NpcRuntimeData[]): void {
    this.npcRuntime = npcs;
  }

  public getNpcRuntime(): NpcRuntimeData[] {
    return this.npcRuntime;
  }

  public updateChestInventory(rows: ChestInventoryRow[]): void {
    this.chestInventory = rows;
  }

  public getChestInventory(): ChestInventoryRow[] {
    return this.chestInventory;
  }

  public markEntityMoveSnap(entityId: string, position: TilePosition): void {
    this.snapNextMoveByEntityId.set(entityId, position);
  }

  public consumeEntityMoveSnap(entityId: string): TilePosition | null {
    const pending = this.snapNextMoveByEntityId.get(entityId) ?? null;
    if (pending) {
      this.snapNextMoveByEntityId.delete(entityId);
    }
    return pending;
  }

  public clear(): void {
    this.remotePlayers.clear();
    this.visualAssets = [];
    this.npcs = [];
    this.runtimeMobs = [];
    this.npcRuntime = [];
    this.chestInventory = [];
    this.snapNextMoveByEntityId.clear();
  }
}
